import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EditableModule } from '@flyfreely-portal-ui/editable';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ReportViewComponent } from './report-view/report-view.component';
import { ReportLayoutComponent } from './report-layout/report-layout.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        EditableModule,
        AnalyticsModule,
        TooltipModule,
        MatSlideToggleModule,
        RouterModule.forChild([]),
        ReportViewComponent,
        ReportLayoutComponent
    ],
    declarations: [],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportingModule {}
